import { AddonTogglerInfo } from "../enums";

/**
 *
 * @param {*} pack
 * @param {PlanType} selectedPlanType
 * @param {String} mode - 'removeObject' or 'clearQuantity'
 * - 'removeObject' - remove the whole object from the array
 * - 'clearQuantity' - set the quantity to 0
 * @returns
 */
const filterAddon = (pack, selectedPlanType, mode) => {
    const info = AddonTogglerInfo[pack.type];
    const { hideInPlans } = info;

    switch (mode) {
        case 'clearQuantity': {
            // remove quantity if it is not available for the selected plan
            if (hideInPlans.includes(selectedPlanType)) {
                return {
                    ...pack,
                    quantity: 0,
                    totalValue: 0,
                    totalPrice: 0,
                };
            }

            return pack;
        }
        case 'removeObject':
            return !hideInPlans.includes(selectedPlanType);
        default:
            return pack;
    }
};

// Filter out non-related plans
// user (not available for Premium)
// data extraction (not available for partner plans)
// whatsapp (not available for partner plans and Launch)
// email (not available for partner plans)
// storage (available for all)

/**
* @param {String} mode - 'removeObject' or 'clearQuantity'
* - 'removeObject' - remove the whole object from the array
* - 'clearQuantity' - set the quantity to 0
* @returns
*/
export const filterPlanAddons = (addonPacks, selectedPlanType, mode = 'removeObject') => {
    // console.log('aaa filterPlanAddons', {addonPacks, selectedPlanType});

    if (mode === 'removeObject')
        return addonPacks.filter(pack => filterAddon(pack, selectedPlanType, 'removeObject'));
    if (mode === 'clearQuantity')
        return addonPacks.map(pack => filterAddon(pack, selectedPlanType, 'clearQuantity'));

    return addonPacks;
};
